exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.padding[data-v-78dd9090]{padding:20px\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/central/comunicacao/ConflitosShape.vue"],"names":[],"mappings":";AA0BA,0BACE,YAAa;CACd","file":"ConflitosShape.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.padding {\n  padding: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78dd9090","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/central/comunicacao/ConflitosShape.vue
// module id = yuL/
// module chunks = 11